import React, {useRef, useEffect,useContext} from "react";
// //imports
import { Typography } from "@material-ui/core";
import Drawer from '@material-ui/core/Drawer';
// import Header from "./Theme_2/Components/Header";
import Toolbar from '@material-ui/core/Toolbar';
// import useStyles from "./Theme_1/ComponentCss";
import ThemeControls from "./AllThemesControl";
import MenuRender from "./Sidebar/MenuRender";
import { SideMenuJson } from "../modules/menu"
//icons imports
import { ReactComponent as DrawerFooterSVG } from "../images/svgicon/personal_setting.svg";
import { MasterContext } from "../services/MasterContext";
export default function SideMenu() {
  const {useStyles, Header} = ThemeControls;
  const classes = useStyles();
  const ref = useRef();
  const [isSideMenuOpen, setSideMenuOpen] = React.useState(false);
  const [menuJson,setMenuJson]=React.useState(SideMenuJson)
  const { userRole } = useContext(MasterContext);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setSideMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    function updateAuth(menuItems, contextPermissions) {
      menuItems.forEach(item => {
        const permissions = userRole?.data?.filter(permission => permission.applicationcontext === item.roleContext);
        if (permissions && permissions.length > 0) {
          for (const permission of permissions) {
              if (permission.accessPersmission === 1) {
                item.auth = true;
              }
          }
      }
        if (item.items) {
          updateAuth(item.items, contextPermissions);
        }
      });
    }
    
    // Create a deep copy of the menu JSON to avoid mutating the original state directly
    const updatedMenuJson = JSON.parse(JSON.stringify(menuJson));
    
    // Update the auth properties based on userRole data
    updateAuth(updatedMenuJson.menus[0].item, userRole?.data);

    // Update the state with the modified menu JSON
    setMenuJson(updatedMenuJson);
  }, [userRole]);

  const handleSideMenuToggle = () => {
    setSideMenuOpen(!isSideMenuOpen);
  };

  return (
    <>
      <Header sideMenuOpen={handleSideMenuToggle}/>
      <div fakeId={"fakeId"} className={`${isSideMenuOpen ? classes.sideMenuOpen : classes.sideMenuClose}`} ref={ref}>
        <div className={classes.root}>
          <Drawer
            className={classes.drawer}
            variant="permanent"
            // classes={{
            //   paper: classes.drawerPaper,
            // }}
          >
            <Toolbar />
            <div className={classes.drawerContainer}>

              <MenuRender menuJson={menuJson} sideMenuOpen={handleSideMenuToggle} />

            </div>
          </Drawer>
          <div className={classes.ftrlgo}>
            {/* <DrawerFooterSVG /> */}
            {/* <img src={GtsLogo} alt="GTS Logo" className={classes.drawerFooterLogo} /> */}
            <Typography className={classes.drawerFooter}>© 2024, All rights reserved.</Typography>
          </div>
        </div>
      </div>
    </>
  );
};


